var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2662 8.71902H4.73577C4.5399 8.71902 4.43053 8.95357 4.55183 9.1137L7.81704 13.4078C7.9105 13.5307 8.09046 13.5307 8.18492 13.4078L11.4501 9.1137C11.5714 8.95357 11.4621 8.71902 11.2662 8.71902Z",
    fill: "#E4E7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73479 7.28098H11.2652C11.4611 7.28098 11.5705 7.04643 11.4492 6.8863L8.18394 2.59219C8.09048 2.46927 7.91052 2.46927 7.81606 2.59219L4.55085 6.8863C4.42955 7.04643 4.53892 7.28098 4.73479 7.28098Z",
    fill: "#E4E7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSort);
export default __webpack_public_path__ + "static/media/arrow-sort.af22e6fb9a8e8ab857b75ae2030ba3f3.svg";
export { ForwardRef as ReactComponent };